import { useLayoutEffect, useState } from "react";
import ResizeObserver from "resize-observer-polyfill";
export function useScrollbarInfo() {
    const [scrollInfo, setScrollInfo] = useState({
        hasYScrollbar: false,
        yScrollbarWidth: 0,
    });
    useLayoutEffect(() => {
        function markIfScrollbarIsPresent(bodyElement) {
            const contentOverflows = bodyElement.scrollHeight > bodyElement.clientHeight;
            if (bodyElement.style.overflowY === "hidden" || !contentOverflows) {
                setScrollInfo((prev) => (Object.assign(Object.assign({}, prev), { hasYScrollbar: false })));
            }
            else if (contentOverflows) {
                const yScrollbarWidth = window.innerWidth - bodyElement.clientWidth;
                setScrollInfo({ hasYScrollbar: true, yScrollbarWidth });
            }
        }
        const styleObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutationRecord) {
                const bodyElement = mutationRecord.target;
                markIfScrollbarIsPresent(bodyElement);
            });
        });
        const resizeObserver = new ResizeObserver(([entry]) => {
            if (entry && entry.target && entry.target instanceof HTMLElement) {
                markIfScrollbarIsPresent(entry.target);
            }
        });
        const target = document.querySelector("body");
        if (target) {
            markIfScrollbarIsPresent(target);
            styleObserver.observe(target, {
                attributes: true,
                attributeFilter: ["clientWidth"],
            });
            resizeObserver.observe(target);
        }
        return () => {
            styleObserver.disconnect();
            resizeObserver.disconnect();
        };
    }, []);
    return scrollInfo;
}
